/*
 * @Descripttion:
 * @version:
 * @Author: 廖图图
 * @Date: 2021-11-16 09:18:11
 * @LastEditors: 廖图图
 * @LastEditTime: 2022-03-25 17:06:01
 */
/**
 * 时间分段
 */
const frontEndPage = {
  getAllFrontEndPages: "/api/getAllFrontEndPages", //获取所有前端页面
  addFrontEndPage: "/api/addFrontEndPage", //增加前端页面
  modifyFrontEndPage: "/api/modifyFrontEndPage", //修改前端页面
  deleteFrontEndPage: "/api/deleteFrontEndPage", //删除前端页面
  setFrontEndPageContainingButtons: "/api/setFrontEndPageContainingButtons", //设置前端页面包含按钮
  getFrontEndPageContainingButtons: "/api/getFrontEndPageContainingButtons", //获取前端页面包含按钮
  getFrontEndPageContainingButtons2: "/api/getFrontEndPageContainingButtons2", //获取前端页面包含按钮
  setFrontEndPageButtonInvolvingOperations:
    "/api/setFrontEndPageButtonInvolvingOperations", //设置前端页面按钮涉及操作权限
  getFrontEndPageButtonInvolvingOperations:
    "/api/getFrontEndPageButtonInvolvingOperations", //获取前端页面按钮涉及操作权限
  getFrontEndPageButtonInvolvingOperations2:
    "/api/getFrontEndPageButtonInvolvingOperations2", //获取前端页面按钮涉及操作权限

  batchGetRoleFrontEndPageParamCustom:
    "/api/batchGetRoleFrontEndPageParamCustom", //获取角色页面路径信息
  batchGetCompanyFrontEndPageDefaultParamBySubSystem:
    "/api/batchGetCompanyFrontEndPageDefaultParamBySubSystem", //获取公司页面路径信息
  addRolePageInstance: "/api/addRolePageInstance", //增加角色页面实例
  deleteRolePageInstance: "/api/deleteRolePageInstance", //删除角色页面实例
  addCompanyIdPageInstance: "/api/addCompanyIdPageInstance", //增加公司页面实例
  deleteCompanyIdPageInstance: "/api/deleteCompanyIdPageInstance", //删除公司页面实例
};

export default frontEndPage;
